import script from "./VideoCard.vue?vue&type=script&setup=true&lang=js"
export * from "./VideoCard.vue?vue&type=script&setup=true&lang=js"

import "./VideoCard.vue?vue&type=style&index=0&id=15455c66&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15455c66"]])

export default __exports__